import { SortKeys, TablePagination } from "@sso/types";

export const tablePaginationInitialValue: TablePagination = {
  pageSize: 10,
  totalItems: 0,
  totalPages: 1,
  pageIndex: 1,
  sort: { column: "", type: SortKeys.NONE },
  search: {},
};
